import { UseQueryOptions } from 'react-query'
import { HTTPError } from '../../api/fetch/decorate-fetch'
import {
  OnboardingServiceArgs,
  OnboardingServiceResponse,
  SCMType,
  postOnboardingService
} from '../../api/queries/onboarding-service/onboarding-service'
import { Query } from '../../hooks/queries'
import { useContrastQuery } from '../../hooks/use-contrast-query'

export interface UseOnboardingServiceResponse {
  isLoading: boolean
  error: HTTPError | null
}

export const useOnboardingService = (
  organizationUuid: string,
  teamServerUrl: string,
  destinationUrl: string,
  scmType: SCMType,
  queryOptions?: UseQueryOptions<OnboardingServiceResponse>
): UseOnboardingServiceResponse => {
  const { isLoading, error } = useContrastQuery<
    OnboardingServiceArgs,
    OnboardingServiceResponse
  >(
    [Query.ONBOARDING_SERVICE, organizationUuid],
    postOnboardingService,
    {
      organizationUuid,
      teamServerUrl,
      destinationUrl,
      scmType
    },
    {
      enabled: true,
      ...queryOptions
    }
  )

  return {
    isLoading,
    error
  }
}
